module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started-large@3x.d2bc9f58.png";